// extracted by mini-css-extract-plugin
module.exports = {"imgWrap":"ImagePortrait_imgWrap__2TvC_","pointer":"ImagePortrait_pointer__3VxGl","carouselImageDescription":"ImagePortrait_carouselImageDescription__1Tz7h"};